import React from 'react'
import styles from './school-head.styles'
import injectSheet from 'react-jss'
import Nav from './nav/nav'
import Head from '../head/head'
import SchoolHeadTitle from './school-head-title/school-head-title.container'

const SchoolHead = ({ classes, title }) => (
  <Head>
    <SchoolHeadTitle />
    <div className={classes.navContianer}>
      <Nav />
    </div>
  </Head>
)

export default injectSheet(styles)(SchoolHead)
